import { LogoDto } from "./LogoDto";

export class Logo {
    private imageModel: LogoDto;

    public format: string | undefined = '';
    public data: string | undefined = '';

    constructor(image?: LogoDto) {
        this.imageModel = !!image ? image : new LogoDto();
        this.SetValues(this.imageModel);
    }

    public Reset() {
        this.SetValues(this.imageModel);
    }

    get HasChanges() {
        return this.format != this.imageModel.format
            || this.data != this.imageModel.data;
    }

    public GetModel() {
        let model = new LogoDto();

        model.id = this.imageModel.id;
        model.format = this.format;
        model.data = this.data;

        return model;
    }

    public SetValues(image?: LogoDto) {
        this.imageModel = !!image ? image : new LogoDto();
        this.format = this.imageModel.format;
        this.data = this.imageModel.data;
    }
}
